










































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DatePicker extends Vue { 
	@Prop(Function) public changeState: any
	@Prop(String) public keyName!: string
	@Prop() public trackid: any

	menu = false
	date = ""
	monthText = ['มกราคม','กุมภาพันธ์', 'มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']

	get dateText() {
      	if (this.date) {
			const [year, month, day] = this.date.split("-")
			return `${day}/${month}/${year}`
		}
    }

	set dateText (newValue: any) {
		this.date = newValue === null ? "" : newValue
		this.changeState(`${this.keyName}`, this.date)
	}

	setYear (date: string){
		return date.substring(0, 4)
	}

	setHeaderDate (date: string) {
		const splitDate: any[] = date.split("-")
		const myText = `${this.monthText[splitDate[1]-1] === undefined ? '' : this.monthText[splitDate[1]-1]} ${date.substring(0, 4)}`
		return myText
	}

	changeDate() {
		this.changeState(`${this.keyName}`, this.date)
		this.menu = false
	}
}
